import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { StandardButtonComponent } from "../standard-button/standard-button.component";
import { ModalWrapperComponent } from "../modal-wrapper/modal-wrapper.component";

@Component({
  selector: 'app-download-modal',
  standalone: true,
  imports: [StandardButtonComponent, MatIconModule, ModalWrapperComponent],
  templateUrl: './app-download-modal.component.html',
  styleUrl: './app-download-modal.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AppDownloadModalComponent {
  readonly dialogRef = inject(MatDialogRef<AppDownloadModalComponent>);

  // URL de Google Play Store
  readonly playStoreUrl = 'https://play.google.com/store/apps/details?id=com.metaeducation.gotalks&hl=es_PE';

  downloadApp() {
    // Marcar que el usuario eligió descargar
    localStorage.setItem('app_download_prompted', 'download');
    
    // Abrir Google Play Store
    window.open(this.playStoreUrl, '_blank');
    
    this.dialogRef.close();
  }

  continueWeb() {
    // Marcar que el usuario eligió continuar en web
    localStorage.setItem('app_download_prompted', 'web');
    
    this.dialogRef.close();
  }

  onClose() {
    // Permitir cerrar sin marcar preferencia
    this.dialogRef.close();
  }
}
